import { useAPI, useAsyncHandler } from '~/hooks/common';

import { API_ENDPOINT } from '~/constants';

import type { TypeGetExchangeOrdersExistenceParams } from '~/types/claim.types';
import type { TypeErrorResponseData } from '~/types/common.types';

/**
 * [반품교환관리] 교환 신청 여부 조회 api 요청 훅
 */
const useGetExchangeOrdersExistence = () => {
  const { runAsync } = useAsyncHandler();

  const getExchangeOrdersExistence = useAPI<TypeGetExchangeOrdersExistenceParams, boolean & { data: unknown }>({
    endpoint: API_ENDPOINT.CLAIM.GET_EXCHANGE_ORDERS_EXISTENCE,
    method: 'get',
  });

  const requestExchangeOrdersExistence = async (
    params: TypeGetExchangeOrdersExistenceParams,
    {
      onSuccess,
      onError,
    }: {
      onSuccess?: (data: boolean) => void;
      onError?: (error: TypeErrorResponseData['error']) => void;
    }
  ) => {
    runAsync(() => getExchangeOrdersExistence({ params }), {
      onSuccess: (data) => onSuccess?.(data),
      onError: (error: TypeErrorResponseData['error']) => onError?.(error),
    });
  };

  return { requestExchangeOrdersExistence };
};

export default useGetExchangeOrdersExistence;
